import { TenantEntity } from '../TenantEntity'

export class AirPortRequirement extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get loadingPortCodes() {
    return this._data.loadingPortCodes
  }
  set loadingPortCodes(loadingPortCodes) {
    this._data.loadingPortCodes = loadingPortCodes || ''
  }
  get dischargingPortCodes() {
    return this._data.dischargingPortCodes
  }
  set dischargingPortCodes(dischargingPortCodes) {
    this._data.dischargingPortCodes = dischargingPortCodes || ''
  }
  get destinationPortCodes() {
    return this._data.destinationPortCodes
  }
  set destinationPortCodes(destinationPortCodes) {
    this._data.destinationPortCodes = destinationPortCodes || ''
  }
  get regions() {
    return this._data.regions
  }
  set regions(regions) {
    this._data.regions = regions || ''
  }
  get carrierId() {
    return this._data.carrierId
  }
  set carrierId(carrierId) {
    this._data.carrierId = carrierId || 0
  }
  get destinationAgent() {
    return this._data.destinationAgent
  }
  set destinationAgent(destinationAgent) {
    this._data.destinationAgent = destinationAgent || 0
  }
  get freightTerm() {
    return this._data.freightTerm
  }
  set freightTerm(freightTerm) {
    this._data.freightTerm = freightTerm || ''
  }
  get cargoType() {
    return this._data.cargoType
  }
  set cargoType(cargoType) {
    this._data.cargoType = cargoType || ''
  }

  get operationRequirements() {
    return this._data.operationRequirements || ''
  }
  set operationRequirements(operationRequirements) {
    this._data.operationRequirements = operationRequirements
  }
  get mawb() {
    return this._data.mawb || false
  }
  set mawb(mawb) {
    this._data.mawb = mawb
  }
  get hawb() {
    return this._data.hawb || false
  }
  set hawb(hawb) {
    this._data.hawb = hawb
  }
}
